<template>
  <div v-if="isPlpReady" class="flex w-full flex-col gap-4 px-[20px] md:w-[320px] md:px-0">
        <section
          class="flex flex-col items-start justify-center self-stretch rounded-[8px] bg-[linear-gradient(292deg,#6A2F29_-12.7%,#7A4545_36.81%,#5A5790_86.32%)] p-6 text-white"
          role="region"
          :aria-labelledby="bannerHeadingId"
        >
            <p class="font-['Visuelt_Pro'] mb-3 text-[12px] font-[400] leading-[130%] tracking-[0.72px] text-white">
                {{ props.productCount }} PRODUCTS FOUND
            </p>
            <h2
              :id="bannerHeadingId"
              class="mb-3 font-['Visuelt_Pro'] text-[32px] font-[400] leading-[110%] tracking-[-0.5px] text-[#FFF]"
            >
                {{ props.content?.title }}
            </h2>
            <p class="mb-6 font-['Visuelt_Pro'] text-[16px] font-[400] leading-[140%] tracking-[-0.08px] text-[#FFF]">
                {{ props.content?.short_description }}
            </p>
            <button
                v-if="showRefineButton"
                type="button"
                class="flex h-[44px] items-center justify-center gap-[8px] px-[16px] py-[12px]  self-start rounded-[4px] bg-[#5A355F80] font-['Visuelt_Pro'] text-[16px] font-[400] leading-[120%] tracking-[-0.04px] text-[#FFF] md:hidden"
                :disabled="props.isFiltering || !hasAvailableFilters"
                :class="{ 'opacity-50': props.isFiltering || !hasAvailableFilters }"
                @click="openMobileRefineModal"
            >
                Refine your results
                <Icon icon="chevron-down" class="h-4 w-4" />
            </button>

            <div
              class="agentic-desktop-filters flex-wrap items-start content-start gap-2 self-stretch hidden md:flex"
              role="group"
              aria-label="Focus area options"
            >
              <ul class="flex flex-wrap items-start content-start gap-2">
                <li v-for="(filter, index) in props.availableFilters" :key="filter.filter_name">
                  <button
                    type="button"
                    class="flex items-center justify-center gap-1 cursor-pointer rounded-[4px] border border-white px-3 py-2"
                    :aria-label="`Focus Area ${filter.display_name}, ${index + 1} of ${props.availableFilters.length}`"
                    :aria-pressed="isSelectedFilter(filter.filter_name)"
                    :disabled="props.isFiltering"
                    @click="emit('select-filter', filter.filter_name)"
                  >
                    {{ filter.display_name }}
                  </button>
                </li>
              </ul>
            </div>
            <div v-if="singleProduct" class="mt-4 hidden gap-2 md:flex">
              <button @click.prevent="handleClick(singleProduct.id)" 
                :aria-label="`${singleProduct.productName} add to cart opens simulated dialog`"
                :title="`${singleProduct.productName} add to cart opens simulated dialog`"
                type="button"
                class="w-[140px] h-[44px] cursor-pointer items-center justify-center gap-1 rounded-[4px] bg-[#6A2F29] px-4 py-3 text-[16px] font-[400] text-white transition"> 
                    Add to cart
              </button>
                <button @click.prevent="onProductClick(singleProduct.url)" class="w-[140px] h-[44px] cursor-pointer items-center justify-center gap-1 rounded-[4px] border border-white px-4 py-3 text-center font-['Visuelt_Pro'] text-[16px] font-[400] text-white transition">
                  View product
               </button>
            </div>
             <div class="mt-4 flex" v-if="!showRefineButton">
               <button
                 type="button"
                 aria-haspopup="dialog"
                 :disabled="props.isFiltering || !props.productData.length"
                 class="flex h-[44px] flex-[1_0_0] cursor-pointer items-center justify-center gap-1 rounded-[4px] bg-[#6A2F29] px-4 py-3 text-sm font-medium text-white transition disabled:cursor-not-allowed disabled:opacity-50"
                 @click="emit('compare-products')">
                     Compare these
               </button>
             </div>
             <div
               v-if="isMobileRefineModalOpen"
               class="fixed inset-0 z-50 flex items-end bg-[#000000A6] md:hidden"
               @click.self="closeMobileRefineModal"
             >
               <section
                 class="w-full rounded-t-[24px] bg-white px-[16px] pb-[24px] pt-[12px]"
                 @touchstart="handleTouchStart"
                 @touchend="handleTouchEnd"
               >
                 <div class="mx-auto mb-[12px] h-1 w-[64px] rounded-full bg-[#D9D9D9]"></div>

                 <h3
                   v-if="props.content?.title"
                   class="text-center font-['Visuelt_Pro'] text-[24px] font-[400] leading-[120%] tracking-[-0.1px] text-[#191919]"
                 >
                   {{ props.content.title }}
                 </h3>

                 <p
                   v-if="props.content?.short_description"
                   class="mt-2 mb-[32px] text-center font-['Visuelt_Pro'] text-[16px] font-[400] leading-[120%] tracking-[-0.04px] text-[#555]"
                 >
                   {{ props.content.short_description }}
                 </p>

                 <div class="mt-6" role="group" aria-label="Focus area options">
                   <ul class="flex flex-col gap-2 space-y-2 sm:flex-row">
                     <li v-for="(filter, index) in props.availableFilters" :key="`mobile-${filter.filter_name}`">
                       <button
                         type="button"
                         class="h-[44px] w-full rounded-[4px] border border-[#B9B9B9] bg-white px-[16px] py-[12.5px] text-center font-['Visuelt_Pro'] text-[16px] font-[400] leading-[120%] tracking-[-0.04px] text-[#191919]"
                         :class="{ 'text-[#999]': isSelectedFilter(filter.filter_name) }"
                         :aria-label="`Focus Area ${filter.display_name}, ${index + 1} of ${props.availableFilters.length}`"
                         :aria-pressed="isSelectedFilter(filter.filter_name)"
                         :disabled="props.isFiltering"
                         @click="selectFilterFromMobileModal(filter.filter_name)"
                       >
                         {{ filter.display_name }}
                       </button>
                     </li>
                   </ul>
                 </div>
               </section>
             </div>
        </section>
  </div>

  <div v-else class="flex w-full flex-col gap-4 px-[20px] md:w-[320px] md:px-0">
    <div
      class="w-full rounded-[8px] bg-[linear-gradient(292deg,#6A2F29_-12.7%,#7A4545_36.81%,#5A5790_86.32%)] p-3 text-white md:max-w-none md:p-6"
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <h2 class="text-[28px] font-normal leading-[110%] tracking-[-0.5px] md:text-3xl md:font-bold">
        We’re grabbing your products
      </h2>
      <p class="mt-3 text-[16px] leading-[140%]">
        Hold on a few seconds while we retrieve your products.
      </p>
      <div
        class="mt-6 h-[5px] w-full overflow-hidden rounded-[8px] bg-[#FFFFFF33]"
        role="progressbar"
        aria-label="Loading products"
      >
        <div class="progress-fill h-full w-0 rounded-[8px] bg-white motion-reduce:w-full motion-reduce:animate-none"></div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { computed, onBeforeUnmount, ref, watch } from 'vue'
import { useCartModalStore } from '@/stores/cartModalStore'
import { useGtmStore } from '~/stores/googleTagManagerStore'
import siteService from '~/composables/siteService'
import { convertPriceStringToFloat } from '~~/shared/utils/price'
import type { AddToCartAnalyticsContext, AgenticProduct } from '~~/shared/types/common'
import Icon from '~/components/ui/atom/icon.vue'

type BannerContent = {
    title?: string
    short_description?: string
}
type BannerFilter = {
    filter_name: string
    display_name: string
}

const props = defineProps<{
    content?: BannerContent
    availableFilters: BannerFilter[],
    selectedFilters: string[],
    productCount?: number
    isFiltering: boolean
    isPlpReady: boolean
    showProductGrid: boolean
    productData: AgenticProduct[]
    isCompareMode?: boolean
}>()

const emit = defineEmits<{
  (e: 'select-filter', filterKey: string): void
  (e: 'compare-products'): void
  (e: 'added'): void
}>()

const router = useRouter()

const goToPreviousPage = () => {
        router.back()
}
const showRefineButton = computed(() => {
  return !props.isCompareMode
})
const normalizeFilterValue = (filter: string) => {
  try {
    return decodeURIComponent(filter.replace(/\+/g, ' ')).trim()
  } catch {
    return filter.replace(/\+/g, ' ').trim()
  }
}

const displayFilters = computed(() => [...new Set(props.selectedFilters
  .flatMap(filter => filter.split(','))
  .map(normalizeFilterValue)
  .filter(Boolean))])
const selectedFilterSet = computed(() => new Set(displayFilters.value))
const isSelectedFilter = (filter: string) => selectedFilterSet.value.has(normalizeFilterValue(filter))
const bannerHeadingId = 'agentic-best-product-matches-heading'

const singleProduct = computed(() => {
  if (props.productCount !== 1) {
    return null
  }
  return props.productData[0] ?? null
})

const singleProductAnalyticsContext = computed<AddToCartAnalyticsContext>(() => {
  const product = singleProduct.value
  const price = convertPriceStringToFloat(product?.price)

  return {
    screen_name: 'Agenticplp_results',
    sub_screen: 'Product_summary',
    item_id: product?.sku,
    item_name: product?.productName ?? product?.name,
    item_category: product?.searchTag ?? product?.benefits?.[0],
    price: Number.isFinite(price) ? price : undefined,
    item_list_id: 'agentic_plp_results',
    item_list_name: 'Agentic PLP Results'
  }
})

const onProductClick = (url: string | undefined) => {
  const productUrl = url ?? ''
  if (productUrl) {
    useGtmStore().selectProductEvent(singleProductAnalyticsContext.value)
    window.location.href = productUrl
  }
}

const cartModalStore = useCartModalStore()
const addToCart = async (productId: number | undefined) => {
  if (!productId) {
    cartModalStore.open()
    return
  }
  try {
    const response = await siteService().addToCart(productId, 1, 0, false, singleProductAnalyticsContext.value) as any
    const modalData = response.lines.find(line => line.productId === productId);
    const totalQuantity = response.lines.reduce((sum, line) => sum + line.quantity, 0);
    cartModalStore.open(
      {
        name: modalData.name,
        subtotal: modalData.subtotal,
        imageUrl: modalData.imageUrl,
        quantity: modalData.quantity,
        id: `add-to-cart-${productId}`
      },
      totalQuantity
    )
  } catch {
    cartModalStore.open()
  }
}

const handleClick = (id: number | undefined) => {
  addToCart(id)
  emit('added')
}

const isMobileRefineModalOpen = ref(false)
const touchStartY = ref(0)

const handleTouchStart = (event: TouchEvent) => {
  const touch = event.touches[0]
  if (!touch) {
    return
  }

  touchStartY.value = touch.clientY
}

const handleTouchEnd = (event: TouchEvent) => {
  const touch = event.changedTouches[0]
  if (!touch) {
    return
  }

  const touchEndY = touch.clientY
  const swipeDistance = touchEndY - touchStartY.value

  // Swipe down closes modal
  if (swipeDistance > 80) {
    closeMobileRefineModal()
  }
}
const hasAvailableFilters = computed(() => props.availableFilters.length > 0)
const bodyScrollLockClass = 'agentic-mobile-modal-open'

const syncBodyScroll = (isOpen: boolean) => {
  if (!import.meta.client) return

  document.body.style.overflow = isOpen ? 'hidden' : ''
  document.body.classList.toggle(bodyScrollLockClass, isOpen)
}

watch(
  isMobileRefineModalOpen,
  (isOpen) => {
    syncBodyScroll(isOpen)
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  syncBodyScroll(false)
})

const openMobileRefineModal = () => {
  if (!hasAvailableFilters.value || props.isFiltering) {
    return
  }
  isMobileRefineModalOpen.value = true
}

const closeMobileRefineModal = () => {
  isMobileRefineModalOpen.value = false
}

const selectFilterFromMobileModal = (filterKey: string) => {
  closeMobileRefineModal()
  emit('select-filter', filterKey)
}

</script>

<style scoped>
@keyframes progress-fill {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

.progress-fill {
  animation: progress-fill 4s ease-in-out infinite;
}
</style>
